import { render, staticRenderFns } from "./capTruong.vue?vue&type=template&id=7ca85417&"
import script from "./capTruong.vue?vue&type=script&lang=js&"
export * from "./capTruong.vue?vue&type=script&lang=js&"
import style0 from "./capTruong.vue?vue&type=style&index=0&lang=css&"
import style1 from "./capTruong.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports